import { createAction } from 'typesafe-actions';
import { AuthActionTypes, AuthState } from './types';

export const setAuth = createAction(AuthActionTypes.SET_AUTH)<AuthState>();
export const removeAuth = createAction(AuthActionTypes.REMOVE_AUTH)();
